import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import "app/LineDetails/index.scss";
import SkeletonComp from "app/common/skeleton";
import { RootState } from "../reducers/index";
import HeaderSection from "../LineDetails/HeaderWrapper";
import SignedInDevicesList from "./SignedInDevicesList";
import ChevronLeft from "../../assets/icons/chevron-left-small-black.svg";
import { useNavigate } from "react-router-dom";
import "./manageDevices.scss";
import { getDevicesDetails } from "./actions";

export default function ManageDevices(): React.ReactElement {
  // const loading = useSelector((state: RootState) => (state.app.apiCallsStatus[0]?.status === 'final' ? false : true))
  const dispatch = useDispatch();
  const linesPayload = useSelector((state: RootState) => state.allLines);
  const { firstName, email } = Object(linesPayload.userDetails);
  const backRef = React.useRef() as React.MutableRefObject<HTMLImageElement>;
  //const manageDevices = useSelector((state: RootState) => state.manageDevices)
  const router = useNavigate();
  // const onAddUser = (): void => {
  //   console.log("add user");
  // };
  const backToHome = () => {
    router("/");
  };

  const handleKeyUp = (event: any, ele: any) => {
    if (event.keyCode === 13) {
      ele.current.click();
    }
  };

  React.useEffect(() => {
    if (linesPayload.userDetails && linesPayload.userDetails?.orig_tmobileid) {
      dispatch(getDevicesDetails());
    }
  }, [linesPayload.userDetails]);
  return (
    <React.Fragment>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid className="welcomeBar" container spacing={2}>
            <img
              tabIndex={0}
              src={ChevronLeft}
              ref={backRef}
              onKeyUp={(event) => handleKeyUp(event, backRef)}
              alt={"ChevronLeft"}
              className="chevron-left"
              onClick={backToHome}
            />
            <HeaderSection
              // onAddUser={onAddUser}
              firstName={firstName}
              email={email}
              loading={linesPayload.loading}
            />

            <Grid item container>
              <SkeletonComp
                loadData={{
                  loading: linesPayload.loading,
                  height: 50,
                  width: 283,
                  className: "smyDigits",
                }}
              >
                <div className="manageMyDigits">
                  <div tabIndex={0}>
                    <span className="digitcount mydigits-left">My DIGITS</span>
                  </div>
                  {/* {manageDevices.devices.length >= 8 && (
                    <div className={`mydigits-right`}>
                      <span>You have the maximum number of decvices logged in, to log </span>
                      <br />
                      <span>in with another instance, please sign out of a device.</span>
                    </div>
                  )} */}
                </div>
              </SkeletonComp>
            </Grid>
            <SignedInDevicesList />
          </Grid>
        </Box>
      </Container>
    </React.Fragment>
  );
}
